/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-20 08:57:41
 *
 *******************************************************/
// @flow

// Display 10 merchandising rules per page
export const NUMBER_MERCHANDISING_PER_PAGE = 20;

// Hide collections if there are many
// Show button More/Less to view all
export const NUMBER_COLLECTION_DISPLAY = 7;

// Rule ranking
export const RANKING = [
  { label: 'AdminHTML.Merchandising.Constant.ranking1_Label', value: 'high' },
  { label: 'AdminHTML.Merchandising.Constant.ranking2_Label', value: 'medium' },
  { label: 'AdminHTML.Merchandising.Constant.ranking3_Label', value: 'low' }
];

// Products must match
export const PRODUCTS_MATCH = [
  { label: 'AdminHTML.Merchandising.Constant.productsMatch1_Label', value: false },
  { label: 'AdminHTML.Merchandising.Constant.productsMatch2_Label', value: true }
];

export const PRODUCT_ATTRIBUTES = [
  { label: 'AdminHTML.Merchandising.Constant.productAttribute1_Label', value: '' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute2_Label', value: 'title' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute3_Label', value: 'product_type' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute4_Label', value: 'vendor' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute5_Label', value: 'price' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute6_Label', value: 'inventory' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute7_Label', value: 'tags' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute8_Label', value: 'created_at' },
  { label: 'AdminHTML.Merchandising.Constant.productAttribute9_Label', value: 'published_at' }
];

export const CONDUCTOR_FOR_PRODUCT_TITLE = [
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label3', value: 'starts_with' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label4', value: 'ends_with' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label5', value: 'contains' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label6', value: 'does_not_contain' }
];

export const CONDUCTOR_FOR_PRODUCT_TYPE = [
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label1', value: 'is_equal_to' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label2', value: 'is_not_equal_to' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label3', value: 'starts_with' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label4', value: 'ends_with' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label5', value: 'contains' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label6', value: 'does_not_contain' }
];

export const CONDUCTOR_FOR_PRODUCT_VENDOR = [
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label1', value: 'is_equal_to' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label2', value: 'is_not_equal_to' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label3', value: 'starts_with' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label4', value: 'ends_with' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label5', value: 'contains' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label6', value: 'does_not_contain' }
];

export const CONDUCTOR_FOR_PRODUCT_PRICE = [
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label1', value: 'is_equal_to' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label2', value: 'is_not_equal_to' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label7', value: 'is_greater_than' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label8', value: 'is_less_than' }
];

export const VALUES_FOR_PRODUCT_INVENTORY = [
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label10', value: 'in stock' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label11', value: 'out-of stock' }
];

export const CONDUCTOR_FOR_PRODUCT_TAG = [{ label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label9', value: 'is_equal_to' }];
export const CONDUCTOR_FOR_PRODUCT_INVENTORY = [{ label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label9', value: 'is_equal_to' }];

export const CONDUCTOR_FOR_DATE = [
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label12', value: 'before' },
  { label: 'AdminHTML.Merchandising.Constant.conductorForProduct_Label13', value: 'after' }
];
